import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBlogs } from "../redux/blogSlice";
import { IoSearchSharp } from "react-icons/io5";
import { Link } from "react-router-dom";
import { FaMedium } from "react-icons/fa6"
import { format } from "date-fns";

export const Blogpage = () => {
    const dispatch = useDispatch();
    const { blogs } = useSelector((state) => state.blogs);

    useEffect(() => {
        dispatch(getBlogs());
    }, [dispatch]);



    const categories = [
        { name: "Advertisement", count: 3 },
        { name: "Agency", count: 12 },
        { name: "Blog", count: 8 },
        { name: "Blog Images", count: 12 },
        { name: "Business", count: 6 }
    ];
    return (
        <>




            <div className="max-w-7xl mx-auto px-4 py-8">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    {/* Main Content */}
                    <div className="lg:col-span-2 space-y-8">
                        {blogs?.map(post => (
                            <article key={post.id} className="border border-gray-200 rounded-lg overflow-hidden">
                                <div className="flex flex-col md:flex-row">
                                    <div className="md:w-1/3">
                                        <img
                                            src={
                                                `/blogs/${post.blog_image}` ||
                                                "https://de+faultimage.com/default.jpg"
                                            } // Default image if none provided
                                            alt={post.title}
                                            className="h-full w-full object-cover"
                                        />
                                    </div>
                                    <div className="p-6 md:w-2/3">
                                        <div className="text-sm text-gray-500 mb-2">
                                            BY {'BBS'} | {format(new Date(post.created_at), "MMMM d, yyyy") || "Date"}
                                        </div>
                                        <h2 className="text-xl font-bold mb-3">{post.title}</h2>
                                        <p className="text-gray-600 mb-4">{post.blog_excerpt}</p>
                                        <button className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition">
                                            <Link
                                                to={`/blogs/view/${post.blog_id}`}
                                                className="font-medium text-lg  hover:text-indigo-600 transition duration-500 ease-in-out inline-block mb-2"
                                            >
                                                {post.title || "Title"}
                                            </Link>
                                        </button>
                                    </div>  
                                </div>
                            </article>
                        ))}
                    </div>

                    {/* Sidebar */}
                    <div className="space-y-8">
                        {/* Search */}
                        <div className="border border-gray-200 rounded-lg p-4">
                            <div className="relative">
                                <input
                                    type="text"
                                    placeholder="Enter your keywords..."
                                    className="w-full border border-gray-200 rounded-lg pl-4 pr-10 py-2"
                                />
                                <IoSearchSharp className="absolute right-3 top-2.5 text-gray-400" size={20} />
                            </div>
                        </div>

                        {/* About Me */}
                        <div className="border border-gray-200 rounded-lg p-4">
                            <h3 className="text-lg font-bold mb-4">ABOUT ME</h3>
                            <img
                                src="https://img.freepik.com/free-photo/portrait-smiling-woman-holding-opened-book_114579-70801.jpg?uid=R180299756&ga=GA1.1.815902557.1738949051&semt=ais_hybrid"
                                alt="About me"
                                className="w-full rounded-lg mb-4"
                            />
                            <p className="text-gray-600">
                                Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry's standard.
                            </p>
                            <button className="mt-4 w-full bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition">
                                ABOUT AUTHOR
                            </button>
                        </div>

                        {/* Follow Us */}
                        <div className="border border-gray-200 rounded-lg p-4">
                            <h3 className="text-lg font-bold mb-4">FOLLOW US</h3>
                            <div className="flex  space-x-2  lg:justify-start sm:mt-0 ">
                                {" "}
                                <Link
                                    target="blank"
                                    to="https://www.facebook.com/profile.php?id=61571089610849"
                                    className="p-3 rounded-full bg-white text-gray-700 group transition-all duration-500 hover:bg-amber-500 hover:text-white focus-within:outline-0 focus-within:bg-amber-500 focus-within:text-white"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={20}
                                        height={20}
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M13.077 10.7339L13.4445 8.43347H11.1808V6.93821C11.1808 6.30919 11.4968 5.69455 12.5074 5.69455H13.5511V3.73561C12.9433 3.64013 12.3292 3.58847 11.7136 3.58105C9.8505 3.58105 8.63412 4.68453 8.63412 6.67941V8.43347H6.56885V10.7339H8.63412V16.298H11.1808V10.7339H13.077Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </Link>
                                <Link
                                    target="blank"
                                    to="https://www.instagram.com/_brain_box_study_"
                                    className="p-3 rounded-full bg-white text-gray-900 group transition-all duration-500 hover:bg-amber-500 hover:text-white focus-within:outline-0 focus-within:bg-amber-500 focus-within:text-white"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={20}
                                        height={20}
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M7.7117 9.93956C7.7117 8.66117 8.76298 7.62456 10.0601 7.62456C11.3573 7.62456 12.4092 8.66117 12.4092 9.93956C12.4092 11.218 11.3573 12.2546 10.0601 12.2546C8.76298 12.2546 7.7117 11.218 7.7117 9.93956ZM6.44187 9.93956C6.44187 11.909 8.06177 13.5055 10.0601 13.5055C12.0585 13.5055 13.6784 11.909 13.6784 9.93956C13.6784 7.97012 12.0585 6.37367 10.0601 6.37367C8.06177 6.37367 6.44187 7.97012 6.44187 9.93956ZM12.9761 6.23228C12.976 6.3971 13.0256 6.55824 13.1184 6.69532C13.2113 6.83239 13.3433 6.93926 13.4978 7.00239C13.6523 7.06552 13.8223 7.08209 13.9863 7.05C14.1503 7.01791 14.301 6.93861 14.4193 6.82211C14.5377 6.70561 14.6182 6.55716 14.6509 6.39552C14.6836 6.23388 14.667 6.06632 14.603 5.91402C14.5391 5.76173 14.4307 5.63153 14.2917 5.53991C14.1527 5.44829 13.9892 5.39935 13.822 5.39928H13.8217C13.5975 5.39939 13.3825 5.48717 13.224 5.64336C13.0654 5.79954 12.9763 6.01136 12.9761 6.23228V6.23228ZM7.21337 15.5922C6.52637 15.5613 6.15296 15.4486 5.90481 15.3533C5.57583 15.2271 5.3411 15.0767 5.0943 14.8338C4.8475 14.591 4.69474 14.3598 4.56722 14.0356C4.47049 13.7912 4.35605 13.4231 4.32482 12.746C4.29066 12.014 4.28384 11.7941 4.28384 9.93962C4.28384 8.08512 4.29123 7.86584 4.32482 7.13323C4.35611 6.45617 4.47139 6.08878 4.56722 5.84362C4.6953 5.51939 4.84784 5.28806 5.0943 5.04484C5.34076 4.80162 5.57526 4.65106 5.90481 4.5254C6.15285 4.43006 6.52637 4.31728 7.21337 4.28651C7.95613 4.25284 8.17925 4.24612 10.0601 4.24612C11.9411 4.24612 12.1644 4.25339 12.9078 4.28651C13.5948 4.31734 13.9676 4.43095 14.2163 4.5254C14.5453 4.65106 14.7801 4.80195 15.0268 5.04484C15.2736 5.28773 15.4258 5.51939 15.5539 5.84362C15.6507 6.08806 15.7651 6.45617 15.7963 7.13323C15.8305 7.86584 15.8373 8.08512 15.8373 9.93962C15.8373 11.7941 15.8305 12.0134 15.7963 12.746C15.765 13.4231 15.65 13.7911 15.5539 14.0356C15.4258 14.3598 15.2733 14.5912 15.0268 14.8338C14.7804 15.0765 14.5453 15.2271 14.2163 15.3533C13.9683 15.4486 13.5948 15.5614 12.9078 15.5922C12.165 15.6258 11.9419 15.6326 10.0601 15.6326C8.1784 15.6326 7.9559 15.6258 7.21337 15.5922V15.5922ZM7.15503 3.03717C6.40489 3.07084 5.8923 3.18806 5.44465 3.35973C4.98105 3.53701 4.58859 3.77484 4.19641 4.16073C3.80423 4.54662 3.56352 4.93401 3.38364 5.39089C3.20945 5.83234 3.09051 6.33723 3.05635 7.07651C3.02162 7.81695 3.01367 8.05367 3.01367 9.93956C3.01367 11.8255 3.02162 12.0622 3.05635 12.8026C3.09051 13.542 3.20945 14.0468 3.38364 14.4882C3.56352 14.9448 3.80429 15.3327 4.19641 15.7184C4.58853 16.1041 4.98105 16.3416 5.44465 16.5194C5.89314 16.6911 6.40489 16.8083 7.15503 16.842C7.90675 16.8756 8.14655 16.884 10.0601 16.884C11.9737 16.884 12.2139 16.8762 12.9653 16.842C13.7155 16.8083 14.2277 16.6911 14.6756 16.5194C15.139 16.3416 15.5317 16.1043 15.9239 15.7184C16.3161 15.3325 16.5563 14.9448 16.7367 14.4882C16.9108 14.0468 17.0304 13.5419 17.064 12.8026C17.0981 12.0616 17.1061 11.8255 17.1061 9.93956C17.1061 8.05367 17.0981 7.81695 17.064 7.07651C17.0298 6.33717 16.9108 5.83206 16.7367 5.39089C16.5563 4.93428 16.3154 4.54723 15.9239 4.16073C15.5323 3.77423 15.139 3.53701 14.6762 3.35973C14.2277 3.18806 13.7154 3.07028 12.9658 3.03717C12.2145 3.00351 11.9743 2.99512 10.0607 2.99512C8.14712 2.99512 7.90675 3.00295 7.15503 3.03717Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </Link>
                                <Link
                                    target="blank"
                                    to="https://x.com/brainboxstudy"
                                    className="p-3 rounded-full bg-white text-gray-700 group transition-all duration-500 hover:bg-amber-500 hover:text-white focus-within:outline-0 focus-within:bg-amber-500 focus-within:text-white"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={20}
                                        height={20}
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M11.3214 8.93666L16.4919 3.05566H15.2667L10.7772 8.16205L7.19141 3.05566H3.05566L8.47803 10.7774L3.05566 16.9446H4.28097L9.022 11.552L12.8088 16.9446H16.9446L11.3211 8.93666H11.3214ZM9.64322 10.8455L9.09382 10.0765L4.72246 3.95821H6.60445L10.1322 8.8959L10.6816 9.66481L15.2672 16.083H13.3852L9.64322 10.8458V10.8455Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </Link>
                                <Link
                                    target="blank"
                                    to="https://medium.com/@brainboxstudy"
                                    className="p-3 w-11 items-center flex justify-center rounded-full bg-white text-gray-700 group transition-all duration-500 hover:bg-amber-500 hover:text-white focus-within:outline-0 focus-within:bg-amber-500 focus-within:text-white"
                                >
                                    <FaMedium />
                                </Link>
                            </div>
                        </div>

                        {/* Categories */}
                        <div className="border border-gray-200 rounded-lg p-4">
                            <h3 className="text-lg font-bold mb-4">CATEGORIES</h3>
                            <ul className="space-y-2">
                                {categories.map(category => (
                                    <li key={category.name} className="flex justify-between items-center">
                                        <a href={`#${category.name.toLowerCase()}`} className="text-gray-600 hover:text-black">
                                            {category.name}
                                        </a>
                                        <span className="text-gray-400">{category.count}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}
